import React from "react";
import { SupervisorLayout } from "@/layouts/SupervisorLayout";
import Reports from "@/pages/Reports";

export default function SupervisorReportsPage() {
  return (
    <SupervisorLayout>
      <div className="p-2 md:p-4">
        <Reports embedded />
      </div>
    </SupervisorLayout>
  );
}
